import { Box, Button, Typography, Modal, Slide, Stack, Tooltip } from "@mui/material"
import {RocketLaunchOutlined as RocketLaunchOutlinedIcon, Close as CloseIcon, CheckCircle as CheckCirleIcon }from '@mui/icons-material';
import { useState, useEffect, useContext } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ToolContext } from "../../context/ToolContext";
import { StartHereRead } from "../../../__business/components/global/RenderAPI";
import { VM } from "../../VM";
import { env } from "../../Env";
import { rqx } from "../../request/API";

export const StartHere = () =>{

    const [progress, setProgress] = useState(0)
    const nav = useHistory()

    const {career_state, tool_state} = useContext(ToolContext)
    const {walkthrough, startHere, readCareerPost,prnzlData } = career_state
    const {__SESSION} = tool_state

    const user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);
    const role = __SESSION.data.uaccess[0].role_name
    const view = VM()

    const handleClick = (name)=>{
        walkthrough.set((prev) => ({...prev, [name]:true}))
    }
    
    const adminFirstTimeTask = [
        {
            task: "Create Career", 
            description : "Create atleast one Career Post",
            done: readCareerPost.data.length !== 0 , 
            path: "/biz/careers/add", 
            condition: false, 
            setter: ()=>{handleClick('createCareer')}
        },

        {
            task: "View Dashboard", 
            description : "Monitor your transaction summary.", 
            done: prnzlData.data.length !== 0 , 
            path: "/biz", condition: false, 
            setter: ()=>{handleClick('viewDashboard')}
        },

        {task: "Review Applicant", description : "Monitor your applicant status", done: false, path: "/biz/applicants/list?type=all", condition: false, setter: ()=>{handleClick('key')}},
        // {task: "Read Aplicant", description : "Applicant List", done: false, path: "/biz/applicants/list?type=all", condition: [0,1,2], setter: ()=>{handleClick('key')}},
    ]

    const regularUserFirstTimeTask = [
        {task: "Create Career", description : "Create atleast Career Post", done: false,condition: false, path: "/", setter: ()=>{handleClick('createCareer')}},
        // {task: "Create your End of Day Report", description : "Submit End of Day Report", done: startHere.data.tasks.order,condition: [0],path: "/reports/sales-report", setter: ()=>{handleClick('eodSalesReport')}},
    ]

    let firstTimeTask = (role === 'Admin' || role === 'Super Admin') ? adminFirstTimeTask : regularUserFirstTimeTask

    // Fetching from API for completion of First Time Tasks
    const readStatus = async()=>{
        const qsp={ 
            user_id: user_id, 
            role: role
        }
        let res = await StartHereRead(qsp)
        startHere.set((prev) => ({...prev, tasks: res}));
    }

    useEffect(() => {
        readStatus()
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
    const fetchData = async () => {  
        const res = await rqx.get(
            `<<tool>>/${env()}/careerpost/careerRead`,
            {    
                company_id: __SESSION.data.uaccess[0].company_id,
            }
        );
        readCareerPost.set(res)
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

    useEffect(() => {
        calculateProgress()
        //eslint-disable-next-line
    }, [readCareerPost.data,prnzlData.data ]);

    const calculateProgress = ()=>{
        const taskDone = firstTimeTask.filter(v => v.done === true)
        setProgress((taskDone.length / firstTimeTask.length * 100).toFixed(0))
    }

    const isConditionMet = (tasks, index) => {
        const condition = tasks[index].condition;
        if (!condition || condition === false || condition.length === 0) return true;
        return condition.every(c => tasks[c]?.done === true);
    };

    const getRequiredTasks = (tasks, index) => {
        const condition = tasks[index].condition;
        if (!condition || condition === false || condition.length === 0) return [];
        return condition.map(c => tasks[c].task);
    };

    return(
        <Box>
            {(firstTimeTask.some(task => task.done === false) || startHere.data.modal) &&
                (view === ""  ?
                    <Button 
                        sx={{ zIndex: 1300, position: 'absolute', right: 40, bottom: 30, bgcolor: '#5DB55D', boxShadow: "0px 0 71px 0px #5db55d78", borderRadius: 8, p: 2, color: "#ffff", "&:hover": {     backgroundColor: "#5DB55D",  }}}
                        onClick={()=>{startHere.set((prev) => ({...prev, modal:true}))}}
                    >
                        <Box sx={{display: "flex", gap: 1}}>
                            {startHere.data.modal ? <CloseIcon/> : <RocketLaunchOutlinedIcon/> }
                            <Typography>{startHere.data.modal ? "Close" : "Start Here"}</Typography>
                        </Box>

                    </Button>
                :
                    <Button 
                        sx={{position: 'absolute', right: 15, bottom: 75, bgcolor: '#5DB55D', boxShadow: "0px 0 71px 0px #5db55d78", borderRadius: 16, p: 2, color: "#ffff", "&:hover": {     backgroundColor: "#5DB55D",  } , display:  { xs: "none", md: "flex" }}}
                        onClick={()=>{startHere.set((prev) => ({...prev, modal:true}))}}
                    >
                        <Box sx={{display:  { xs: "none", md: "flex" }, gap: 1, alignItems: "center"}}>
                            {startHere.data.modal ? <CloseIcon sx={{fontSize: 12}}/> : <RocketLaunchOutlinedIcon sx={{fontSize: 24}}/> }
                            <Typography fontSize={14}>{startHere.data.modal ? "Close" : "Start Here"}</Typography>
                        </Box>
                    </Button>
                )
            }
            
            { view === '' ?
                <Modal open={startHere.data.modal} slotProps={{backdrop: {sx: { backgroundColor: "transparent" }}}} onClose={()=>{startHere.set((prev) => ({...prev, modal:false}))}} >
                    <Slide in={startHere.data.modal} direction="up" >   
                        <Box boxShadow="0px 8px 16px 0px #00000014;" sx={{bgcolor: "#fff", width: 400, px: 3, py: 2, borderRadius: 4, position: "absolute", right: 40, bottom: 100}}>
                            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}} >
                                <Typography mb={1} fontWeight={600}>Start Here</Typography>
                                <CloseIcon onClick={()=>{startHere.set((prev) => ({...prev, modal:false}))}} sx={{fontSize: 20}}/>
                            </Box>
                            <Typography fontSize={13} mb={1}>
                                Complete these steps to jump start your business with POFCareers.
                            </Typography>
                            <Box sx={{display: "flex", alignItems: "center", width: "100%", gap: 2}}>
                                <Typography sx={{fontWeight: 800, color: "primary.main"}}>{progress}%</Typography>
                                <Box sx={{width: "100%", height: "100%"}}>
                                <LinearProgress variant="determinate" value={progress} sx={{height: 10, borderRadius: 4}} />
                                </Box>
                            </Box>
                            {firstTimeTask.map((v, index)=>(
                                <Tooltip key={index} arrow={true} disableFocusListener placement="top" sx={{bgcolor: "#003022"}} title={!isConditionMet(firstTimeTask, index) ? "Pre-requisites: \n" + getRequiredTasks(firstTimeTask, index).join("\n"): ""} slotProps={{tooltip: { sx: { whiteSpace: 'pre-line', backgroundColor: "#003022" }}, arrow: {sx:{color: "#003022"}} }}>
                                    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", my: 2}}>
                                        <Stack>
                                            <Typography sx={{color: '#292C2F', fontSize: 14, fontWeight: 600}}>{v.task}</Typography>
                                            <Typography sx={{color: '#292C2F', fontSize: 12, fontStyle: 'italic'}}>{v.description}</Typography>
                                        </Stack>
                                    
                                        {v.done ? 
                                            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 70}}>
                                                <Typography sx={{fontSize: 14, color: "#5DB55D"}}>Done</Typography><CheckCirleIcon sx={{color: "#5DB55D" }}/>
                                            </Box> 
                                        : 
                                            isConditionMet(firstTimeTask, index) ?
                                                <Button onClick={()=>{nav.push(v.path); startHere.set((prev) => ({...prev, modal:false})); v.setter();}} sx={{bgcolor: "#e2e2e2ff", color: "#141414ff", fontSize: 14}}>Proceed</Button>
                                            :
                                                <Box sx={{color: '#cfcfcfff', fontSize: 14, fontWeight: 600, bgcolor: "#f7f7f7ff", p:1}}>Proceed</Box>
                                        }
                                    </Box>
                                </Tooltip>
                            ))}
                        </Box>
                    </Slide> 
                </Modal>
            :
                <Modal open={startHere.data.modal} slotProps={{backdrop: {sx: { backgroundColor: "transparent" }}}} onClose={()=>{startHere.set((prev) => ({...prev, modal:false}))}} >
                    <Slide in={startHere.data.modal} direction="up" >   
                        <Box boxShadow="0px 8px 16px 0px #00000014;" sx={{bgcolor: "#fff", height: "auto", maxHeight: "50%", width: "100%", px: 3, py: 2, borderTopLeftRadius: 4, borderTopRightRadius: 4, position: 'absolute', bottom: 0}}>
                            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}} >
                                <Typography mb={1} fontWeight={600}>Start Here</Typography>
                                <CloseIcon onClick={()=>{startHere.set((prev) => ({...prev, modal:false}))}} sx={{fontSize: 20}}/>
                            </Box>
                            <Typography fontSize={13} mb={1}>
                                Complete these steps to jump start your business with Point of Sale.
                            </Typography>
                            <Box sx={{display: "flex", alignItems: "center", width: "100%", gap: 2}}>
                                <Typography sx={{fontWeight: 800, color: "primary.main"}}>{progress}%</Typography>
                                <Box sx={{width: "100%", height: "100%"}}>
                                <LinearProgress variant="determinate" value={progress} sx={{height: 10, borderRadius: 4}} />
                                </Box>
                            </Box>
                            {firstTimeTask.map((v, index)=>(
                                <Box key={index} sx={{display: "flex", justifyContent: "space-between", alignItems: "center", my: 2}}>
                                    <Stack>
                                        <Typography sx={{color: '#292C2F', fontSize: 14, fontWeight: 600}}>{v.task}</Typography>
                                        <Typography sx={{color: '#292C2F', fontSize: 12, fontStyle: 'italic'}}>{v.description}</Typography>
                                    </Stack>
                                    {v.done ? 
                                        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 70}}>
                                            <Typography sx={{fontSize: 14, color: "#5DB55D"}}>Done</Typography><CheckCirleIcon sx={{color: "#5DB55D" }}/>
                                        </Box> 
                                    : 
                                        isConditionMet(firstTimeTask, index) ?
                                            <Button onClick={()=>{nav.push(v.path); startHere.set((prev) => ({...prev, modal:false})); v.setter();}} sx={{bgcolor: "#e2e2e2ff", color: "#141414ff", fontSize: 14}}>Proceed</Button>
                                        :
                                            <Box sx={{color: '#cfcfcfff', fontSize: 14, fontWeight: 600, bgcolor: "#f7f7f7ff", p:1}}>Proceed</Box>
                                    }
                                </Box>
                            ))}
                        </Box>
                    </Slide> 
                </Modal>
            }
        </Box>
    )
}